import React, { useRef, useState, useEffect, useCallback } from 'react';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import { DataGrid, GridColDef, GridCellParams, GridRowId, ptBR } from '@material-ui/data-grid';
import { createMuiTheme, ThemeProvider, makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import ButtonDialog from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FiCopy } from 'react-icons/fi';
import { MdDelete, MdEdit, MdClear, MdSkipNext, MdSkipPrevious, MdContentCopy } from 'react-icons/md';
import {
  AiOutlineSearch,
  AiOutlinePlus,
  AiOutlineSave,
  AiFillFastBackward,
  AiFillFastForward,
  AiOutlineCaretDown,
  AiOutlineCaretUp,
} from 'react-icons/ai';
import { RiDeleteBinLine } from 'react-icons/ri';
import { GoPlus } from 'react-icons/go';
import InputComum from '../../components/InputComum';
import Checkbox from '../../components/Checkbox';
import Select from '../../components/Select';
import Header from '../../components/Header';
import FormModalDialogConfirm from '../../components/FormModalDialogConfirm';

import api from '../../services/api';
import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';

import getListUpdateV2 from '../../utils/getListUpdateV2';
import { getPathGrid } from '../../utils/storagePath';
import getValidationErrors from '../../utils/getValidationErrors';
import { getCNPJMask, getCpfFormated } from '../../utils/getCNPJMask';
import { CNPJ } from '../../utils/cnpj';
import { isEmailValid, isNameValid, isValidCPF } from '../../utils/Validations';

import {
  ColumnObservacao,
  ColumnInformacao1,
  ColumnInformacao2,
  ColumnInformacao3,
  ColumnInformacao4,
  ColumnInformacao5,
  ColumnID,
  ColumnAtivo,
  ColumnCodigo,
  ColumnContato,
  ColumnEmail,
  ColumnEndereco,
  ColumnInscricaoEstatual,
  ColumnInscricaoMunicipal,
  ColumnNome,
  ColumnNomeFantasia,
  ColumnTelefone,
  ColumnTipoPessoa,
  ColumnVinculoPessoa,
} from './GridColumns';

import ICadPessoas, { emptyCadPessoas } from './ICadPessoas';
import IAPICadPessoas from './IAPICadPessoas';

import {
  Container,
  ContainerFields,
  Tab,
  TabButton,
  TabContent,
  FormFields,
  FormContainer,
  FormNavigate,
  TabTitulo,
  TabButtonArea,
  TabButtonNovo,
  TabButtonDelete,
  TabButtonGridRowHeight,
  SpanFiltro,
  ContainerFilterSelect,
  ContainerFieldCheckbox,
  ContainerFilterInput,
  ContainerFlexRow,
  ContainerFieldsHidden,
} from './styles';

const useStylesLoading = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 2000,
      color: '#fff',
    },
  }),
);

const theme = createMuiTheme(
  {
    palette: {
      primary: { main: '#006699' },
    },
  },
  ptBR,
);

interface ICadPessoasFilter {
  license: string;
  tipo_pessoa?: string;
  vinculo_pessoa?: string;
  nome?: string;
  inscricao_federal?: string;
  inscricaoFederalLike?: string;
}

const titulo = 'P E S S O A S';
const idfieldSelectUser = '22swdf515533rasd12W';
const optionsTipoPessoa = ['1-Jurídica', '2-Física', '3-Estrangeira', '9-Outros'];
const optionsVinculoPessoa = ['1-Cliente', '2-Fornecedor', '3-Ambos'];

const CadPessoas: React.FC = () => {
  const { user } = useAuth();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const [cadPessoas, setCadPessoas] = useState<ICadPessoas>();
  const [listCadPessoas, setListCadPessoas] = useState<ICadPessoas[]>([]);
  const [hiddenPesquisar, setHiddenPesquisar] = useState<boolean>(false);
  const [hiddenCadastrar, setHiddenCadastrar] = useState<boolean>(true);
  const [rowIndex, setRowIndex] = useState<number>(0);
  const [rowToEdit, setRowToEdit] = useState(null);
  const [accessKeyDeleteCadPessoas, setAccessKeyDeleteCadPessoas] = useState<string>('');
  const [selectedIds, setSelectedIds] = useState<GridRowId[]>([]);
  const [openDeleteSingle, setOpenDeleteSingle] = useState(false);
  const [openDeleteMultiple, setOpenDeleteMultiple] = useState(false);
  const [openLoading, setOpenLoading] = useState(false);
  const cssLoading = useStylesLoading();
  const [gridRowHeight, setGridRowHeight] = useState<number>(46);
  const [openFilter, setOpenFilter] = React.useState(true);
  const [textFiltro, setTextFiltro] = useState<string>('');
  const [filtroTipoPessoa, setFiltroTipoPessoa] = useState<string>('Todos');
  const [filtroVinculoPessoa, setFiltroVinculoPessoa] = useState<string>('Todos');
  const [filtroNome, setFiltroNome] = useState<string>('');
  const [filtroInscricaoFederal, setFiltroInscricaoFederal] = useState<string>('');
  const [cadPessoaVerify, setCadPessoaVerify] = useState<ICadPessoas>();
  const [tempCadPessoa, setTempCadPessoa] = useState<ICadPessoas>();
  const [openCadPessoaVerify, setOpenCadPessoaVerify] = React.useState(false);

  const handleCloseFilter = useCallback(() => {
    setOpenFilter(false);
  }, []);

  const handleCloseCadPessoaVerify = useCallback(() => {
    setOpenCadPessoaVerify(false);
  }, []);

  const handleGridRowHeightUp = useCallback(async () => {
    const heightValue: number = gridRowHeight + 1;
    setGridRowHeight(heightValue);
    localStorage.setItem(getPathGrid(), heightValue.toString());
  }, [gridRowHeight]);

  const handleGridRowHeightDown = useCallback(async () => {
    const heightValue: number = gridRowHeight - 1;
    setGridRowHeight(heightValue);
    localStorage.setItem(getPathGrid(), heightValue.toString());
  }, [gridRowHeight]);

  const licencaInvalida = useCallback((): boolean => {
    if (!user.license || user.license.id === '') {
      addToast({
        type: 'error',
        title: 'Licença inválida',
        description: 'Usuário não está vinculado a nenhuma licença',
      });

      return true;
    }

    return false;
  }, [addToast, user]);

  const defineCadPessoas = useCallback(async (inValue: ICadPessoas) => {
    const temp = { ...inValue };
    setCadPessoas(temp);
    formRef.current?.setData(temp);
  }, []);

  const OnGridSetRegisterToEdit = useCallback(
    async (params: GridCellParams) => {
      const localRow = params.row as ICadPessoas;

      setRowIndex(listCadPessoas.indexOf(localRow));
      setHiddenCadastrar(false);
      setHiddenPesquisar(true);
      setRowToEdit(null);
      defineCadPessoas(localRow);
    },
    [listCadPessoas, defineCadPessoas],
  );

  const onNewRegister = useCallback(async () => {
    defineCadPessoas(emptyCadPessoas);
  }, [defineCadPessoas]);

  const OnSetRegisterToAdd = useCallback(async () => {
    onNewRegister();
    setHiddenCadastrar(false);
    setHiddenPesquisar(true);
  }, [onNewRegister]);

  const OnGridRowDuplicate = useCallback(
    async (inValue: ICadPessoas | undefined) => {
      if (inValue !== undefined) {
        const newRow: ICadPessoas = {
          ...inValue,
          access_key: '',
          id: 0,
          codigo: 0,
        };

        defineCadPessoas(newRow);
        setHiddenCadastrar(false);
        setHiddenPesquisar(true);
      }
    },
    [defineCadPessoas],
  );

  const OnConfirmationDeleteSingle = useCallback(
    async (inAccessKey: string) => {
      if (licencaInvalida()) return;

      if (inAccessKey === '') return;

      setAccessKeyDeleteCadPessoas(inAccessKey);
      setOpenDeleteSingle(true);
    },
    [licencaInvalida],
  );

  const colunaAcao: GridColDef = {
    field: 'acao',
    headerName: 'Ação',
    editable: false,
    filterable: false,
    hideSortIcons: true,
    sortable: false,
    disableColumnMenu: true,
    width: 160,
    renderCell: (params: GridCellParams) => (
      <strong>
        <Tooltip title="Editar Registro" placement="top">
          <IconButton color="primary" aria-label="Editar" onClick={() => OnGridSetRegisterToEdit(params)}>
            <MdEdit />
          </IconButton>
        </Tooltip>

        <Tooltip title="Duplicar Registro" placement="top">
          <IconButton
            color="primary"
            aria-label="Duplicar"
            onClick={() => OnGridRowDuplicate(params.row as ICadPessoas)}
          >
            <FiCopy />
          </IconButton>
        </Tooltip>

        <Tooltip title="Excluir Registro" placement="top">
          <IconButton
            color="primary"
            aria-label="Excluir"
            onClick={() => OnConfirmationDeleteSingle((params.row as ICadPessoas).access_key)}
          >
            <MdDelete />
          </IconButton>
        </Tooltip>
      </strong>
    ),
  };

  const ColumnInscricaofederal: GridColDef = {
    field: 'inscricao_federal',
    headerName: 'Inscrição federal',
    width: 200,
    renderCell: (params: GridCellParams) => {
      const localTipo = (params.row as IAPICadPessoas).tipo_pessoa;
      const val = params.value?.toString() ?? '';
      let localLabel = val;
      if (['1-Jurídica', '2-Física'].includes(localTipo))
        localLabel = localTipo === '1-Jurídica' ? getCNPJMask(val) : getCpfFormated(val);
      return <span>{localLabel}</span>;
    },
  };

  const columns: GridColDef[] = [
    colunaAcao,
    ColumnAtivo,
    ColumnCodigo,
    ColumnNome,
    ColumnVinculoPessoa,
    ColumnInscricaofederal,
    ColumnInscricaoEstatual,
    ColumnInscricaoMunicipal,
    ColumnNomeFantasia,
    ColumnTipoPessoa,
    ColumnTelefone,
    ColumnEmail,
    ColumnEndereco,
    ColumnContato,
    ColumnObservacao,
    ColumnInformacao1,
    ColumnInformacao2,
    ColumnInformacao3,
    ColumnInformacao4,
    ColumnInformacao5,
    ColumnID,
  ];

  useEffect(() => {
    if (licencaInvalida()) return;
    setHiddenPesquisar(false);

    const rowHeight = localStorage.getItem(getPathGrid());
    if (rowHeight) {
      setGridRowHeight(parseInt(rowHeight, 10));
    }
  }, [licencaInvalida]);

  const existePessoa = useCallback(
    async (inInscricaoFederal: string) => {
      setCadPessoaVerify(emptyCadPessoas);
      const localFilterParams: ICadPessoasFilter = {
        license: user.license.id,
        inscricao_federal: inInscricaoFederal,
      };
      const response = await api.post<IAPICadPessoas[]>(`/cadpessoas/filter`, localFilterParams);
      if (response.data.length) {
        setCadPessoaVerify(response.data[0]);
        return true;
      }
      return false;
    },
    [user],
  );

  const handleOnRowDeleteSingle = useCallback(async () => {
    setOpenLoading(true);
    await api
      .delete(`/cadpessoas/${accessKeyDeleteCadPessoas}`)
      .then(() => {
        setListCadPessoas(OldValue => OldValue.filter(item => item.access_key !== accessKeyDeleteCadPessoas));
        addToast({
          type: 'success',
          title: 'Removido',
          description: 'Registro excluído com sucesso!',
        });
        setOpenDeleteSingle(false);
        setOpenLoading(false);
      })
      .catch(() => {
        setOpenDeleteSingle(false);
        setOpenLoading(false);
        addToast({
          type: 'error',
          title: 'Não foi possível remover a pessoa',
          description: 'Existe um lançamento vínculado a essa pessoa',
        });
      });
  }, [accessKeyDeleteCadPessoas, addToast]);

  const handleOnRowDeleteMultiple = useCallback(async () => {
    setOpenLoading(true);

    if (selectedIds.length > 0) {
      await Promise.all(
        selectedIds.map(accessKey => {
          setListCadPessoas(itemList => itemList.filter(item => item.access_key !== accessKey));
          return api.delete(`/cadpessoas/${accessKey}`);
        }),
      );
      addToast({
        type: 'success',
        title: 'Removido',
        description: 'Registro excluído com sucesso!',
      });
    }
    setSelectedIds([]);
    setOpenDeleteMultiple(false);
    setOpenLoading(false);
  }, [addToast, selectedIds]);

  const handleClick = useCallback((id: string): void => {
    if (id === 'filtro') {
      setFiltroNome('');
      setFiltroInscricaoFederal('');
      setFiltroTipoPessoa('Todos');
      setFiltroVinculoPessoa('Todos');
      setOpenFilter(id === 'filtro');
      return;
    }
    setHiddenCadastrar(id === 'pesquisar');
    setHiddenPesquisar(id === 'cadastrar');
  }, []);

  const onNextRegister = useCallback(async () => {
    if (rowIndex !== undefined) {
      if (rowIndex < listCadPessoas.length - 1) {
        const localIndex = rowIndex + 1;
        setRowIndex(localIndex);
        const findItem = listCadPessoas[localIndex];
        if (findItem) {
          defineCadPessoas(findItem);
        }
      }
    }
  }, [rowIndex, listCadPessoas, defineCadPessoas]);

  const onFirstRegister = useCallback(async () => {
    if (listCadPessoas.length > 0) {
      setRowIndex(0);
      const findItem = listCadPessoas[0];
      if (findItem) {
        defineCadPessoas(findItem);
      }
    }
  }, [listCadPessoas, defineCadPessoas]);

  const onLastRegister = useCallback(async () => {
    if (listCadPessoas.length > 0) {
      setRowIndex(listCadPessoas.length - 1);
      const findItem = listCadPessoas[listCadPessoas.length - 1];
      if (findItem) {
        defineCadPessoas(findItem);
      }
    }
  }, [listCadPessoas, defineCadPessoas]);

  const onPriorRegister = useCallback(async () => {
    if (rowIndex !== undefined) {
      if (rowIndex > 0) {
        const localIndex = rowIndex - 1;
        setRowIndex(localIndex);
        const findItem = listCadPessoas[localIndex];
        if (findItem) {
          defineCadPessoas(findItem);
        }
      }
    }
  }, [rowIndex, listCadPessoas, defineCadPessoas]);

  const onCancelRegister = useCallback(async () => {
    formRef.current?.setErrors({});

    if (rowIndex !== undefined) {
      const findItem = listCadPessoas[rowIndex];
      if (findItem) {
        defineCadPessoas(findItem);
      }
    }
  }, [rowIndex, listCadPessoas, defineCadPessoas]);

  const isTipoPessoaValid = useCallback((inValue: string): boolean => {
    return optionsTipoPessoa.includes(inValue);
  }, []);

  const isVinculoPessoaValid = useCallback((inValue: string): boolean => {
    return optionsVinculoPessoa.includes(inValue);
  }, []);

  const isNomeValid = useCallback((inTipoPessoa: string, inValue: string): boolean => {
    if (inTipoPessoa === '2-Física') {
      return isNameValid(inValue);
    }
    return true;
  }, []);

  const isInscricaoFederallValid = useCallback((inTipoPessoa: string, inValue: string): boolean => {
    if (inTipoPessoa === '1-Jurídica') {
      return CNPJ.isValid(inValue);
    }
    if (inTipoPessoa === '2-Física') {
      return isValidCPF(inValue);
    }
    return true;
  }, []);

  const salvar = useCallback(
    async (data: ICadPessoas) => {
      try {
        setOpenLoading(true);
        const regexCaracteresMascara = /[./-]/g;

        const formData: ICadPessoas = {
          acao: data.acao,
          id: data.id,
          access_key: data.access_key,
          id_license: data.id_license,
          ativo: data.ativo,
          codigo: data.codigo,
          contato: data.contato,
          email: data.email,
          endereco: data.endereco,
          inscricao_estatual: data.inscricao_estatual,
          inscricao_federal: data.inscricao_federal.replace(regexCaracteresMascara, ''),
          inscricao_municipal: data.inscricao_municipal,
          nome: data.nome,
          nome_fantasia: data.nome_fantasia,
          telefone: data.telefone,
          tipo_pessoa: data.tipo_pessoa,
          vinculo_pessoa: data.vinculo_pessoa,
          inf1: data.inf1,
          inf2: data.inf2,
          inf3: data.inf3,
          inf4: data.inf4,
          inf5: data.inf5,
          obs: data.obs,
          updated_at: data.updated_at,
          created_at: data.created_at,
        };

        if ([0, '0', null, undefined].includes(data.id)) {
          const response = await api.post(`/cadpessoas`, {
            ...formData,
            id_license: user.license.id,
            id: 0,
            access_key: '',
          });
          formData.id = response.data.id;
          formData.codigo = response.data.codigo;
          formData.access_key = response.data.access_key;
          setListCadPessoas(oldValues => [...oldValues, formData]);

          addToast({
            type: 'success',
            title: 'Adicionado',
            description: 'Registro adicionado com sucesso!',
          });
        } else {
          await api.put(`/cadpessoas/${formData.access_key}`, formData);

          setListCadPessoas(getListUpdateV2(listCadPessoas, formData));

          addToast({
            type: 'success',
            title: 'Alterado',
            description: 'Registro alterado com sucesso!',
          });
        }
        setHiddenPesquisar(true);
        setOpenLoading(false);
      } catch (error) {
        setOpenLoading(false);
        addToast({
          type: 'error',
          title: 'Ocorreu um erro ao salvar',
          description: error instanceof Error ? error.message : '',
        });
      }
    },
    [listCadPessoas, addToast, user],
  );

  const handleSubmit = useCallback(
    async (data: ICadPessoas, { reset }) => {
      if (licencaInvalida()) return;
      data.id_license = user.license.id;

      formRef.current?.setErrors({});
      try {
        const schema = Yup.object().shape({
          ativo: Yup.boolean(),
          codigo: Yup.number(),
          tipo_pessoa: Yup.string()
            .required('Tipo pessoa é obrigatório')
            .test('tipo-pessoa-valid', 'Tipo pessoa é inválido', value => {
              return isTipoPessoaValid(value as string);
            }),
          vinculo_pessoa: Yup.string()
            .required('Vínculo pessoa é obrigatório')
            .test('vinculo-pessoa-valid', 'Vínculo pessoa é inválido', value => {
              return isVinculoPessoaValid(value as string);
            }),
          nome: Yup.string()
            .required('Nome é obrigatório')
            .test('nome-pessoa-valid', 'Nome é inválido', value => {
              return isNomeValid(data.tipo_pessoa, value as string);
            }),
          nome_fantasia: Yup.string(),
          inscricao_federal: Yup.string()
            .required('Inscrição federal é obrigatória')
            .test('inscricao-federal-valid', 'Inscrição federal é inválida', value => {
              return isInscricaoFederallValid(data.tipo_pessoa, value as string);
            }),
          inscricao_estatual: Yup.string(),
          inscricao_municipal: Yup.string(),
          endereco: Yup.string(),
          telefone: Yup.string(),
          email: Yup.string().test('email-valid', 'E-mail é inválido', value => {
            if (!value) return true;
            return isEmailValid(value as string);
          }),
          obs: Yup.string(),
          inf1: Yup.string(),
          inf2: Yup.string(),
          inf3: Yup.string(),
          inf4: Yup.string(),
          inf5: Yup.string(),
        });

        await schema.validate(data, {
          abortEarly: false,
        });
        const regexCaracteresMascara = /[./-]/g;
        if ([0, '0', null, undefined].includes(data.id)) {
          const localFindCadPessoa = await existePessoa(data.inscricao_federal.replace(regexCaracteresMascara, ''));
          if (localFindCadPessoa) {
            setTempCadPessoa(data);
            setOpenCadPessoaVerify(true);
          } else {
            await salvar(data);
            reset();
          }
        } else {
          await salvar(data);
          reset();
        }
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }
      }
    },
    [
      licencaInvalida,
      user,
      isNomeValid,
      isInscricaoFederallValid,
      isTipoPessoaValid,
      isVinculoPessoaValid,
      salvar,
      existePessoa,
    ],
  );

  const handleOnFilter = useCallback(async () => {
    setOpenLoading(true);
    let localTextFiltro = '';
    const localFilterParams: ICadPessoasFilter = {
      license: user.license.id,
    };

    if (filtroTipoPessoa && filtroTipoPessoa !== 'Todos') {
      localFilterParams.tipo_pessoa = filtroTipoPessoa;
      localTextFiltro += `Tipo pessoa: ${filtroTipoPessoa}. `;
    }

    if (filtroVinculoPessoa && filtroVinculoPessoa !== 'Todos') {
      localFilterParams.vinculo_pessoa = filtroVinculoPessoa;
      localTextFiltro += `Vínculo pessoa: ${filtroVinculoPessoa}. `;
    }

    if (filtroNome) {
      localFilterParams.nome = filtroNome;
      localTextFiltro += `Nome: ${filtroNome}. `;
    }

    if (filtroInscricaoFederal) {
      localFilterParams.inscricaoFederalLike = filtroInscricaoFederal;
      localTextFiltro += `Inscrição federal: ${filtroInscricaoFederal}. `;
    }

    const response = await api.post<IAPICadPessoas[]>(`/cadpessoas/filter`, localFilterParams);
    setListCadPessoas(response.data);
    if (rowToEdit !== null) {
      const findItem = response.data.find(item => item.access_key === rowToEdit);

      if (findItem) {
        defineCadPessoas(findItem);
        setRowIndex(response.data.indexOf(findItem));
        setHiddenCadastrar(false);
        setHiddenPesquisar(true);
        setRowToEdit(null);
      }
    }
    setTextFiltro(`   Filtrado por: ${localTextFiltro}`);
    setOpenLoading(false);
    setOpenFilter(false);
    handleClick('pesquisar');
  }, [
    user,
    rowToEdit,
    defineCadPessoas,
    handleClick,
    filtroTipoPessoa,
    filtroVinculoPessoa,
    filtroNome,
    filtroInscricaoFederal,
  ]);

  const handleFilterSelectTipoPessoaChange = (event: React.ChangeEvent<{ value: string }>): void => {
    const localValue = event.target.value as string;
    setFiltroTipoPessoa(localValue);
  };

  const handleFilterSelectVinculoPessoaChange = (event: React.ChangeEvent<{ value: string }>): void => {
    const localValue = event.target.value as string;
    setFiltroVinculoPessoa(localValue);
  };

  const handleFilterInputNomeChange = (event: React.ChangeEvent<{ value: string }>): void => {
    const localValue = event.target.value as string;
    setFiltroNome(localValue);
  };

  const handleFilterInputInscricaoFederalChange = (event: React.ChangeEvent<{ value: string }>): void => {
    const localValue = event.target.value as string;
    setFiltroInscricaoFederal(localValue);
  };

  const handleOnConfirmCreate = useCallback(async () => {
    if (tempCadPessoa) await salvar(tempCadPessoa);
    defineCadPessoas(emptyCadPessoas);
    setTempCadPessoa(emptyCadPessoas);
    setOpenCadPessoaVerify(false);
  }, [defineCadPessoas, salvar, tempCadPessoa]);

  return (
    <Container>
      <Header />

      <Tab>
        <TabButtonArea>
          <TabButton id="pesquisar" isActive={!hiddenPesquisar} onClick={() => handleClick('pesquisar')}>
            Listagem
          </TabButton>

          <TabButton id="cadastrar" isActive={!hiddenCadastrar} onClick={() => handleClick('cadastrar')}>
            Cadastro
          </TabButton>

          <Tooltip title="Reduzir o tamanho da linha" placement="top">
            <TabButtonGridRowHeight id="gridrowheightdown" onClick={() => handleGridRowHeightDown()}>
              <AiOutlineCaretDown />
            </TabButtonGridRowHeight>
          </Tooltip>

          <Tooltip title="Aumentar o tamanho da linha" placement="top">
            <TabButtonGridRowHeight id="gridrowheightup" onClick={() => handleGridRowHeightUp()}>
              <AiOutlineCaretUp />
            </TabButtonGridRowHeight>
          </Tooltip>

          <Tooltip title="Pesquisar" placement="top">
            <TabButton id="filtro" isActive={false} onClick={() => handleClick('filtro')}>
              <AiOutlineSearch />
            </TabButton>
          </Tooltip>

          <Tooltip title="Novo Registro" placement="top">
            <TabButtonNovo id="new_register" onClick={() => OnSetRegisterToAdd()}>
              <GoPlus />
              Novo
            </TabButtonNovo>
          </Tooltip>

          <Tooltip title="Remover Registros Selecionados" placement="top">
            <span>
              <span hidden={selectedIds.length <= 0}>
                <TabButtonDelete
                  id="remove_all"
                  onClick={() => {
                    setAccessKeyDeleteCadPessoas('');
                    setOpenDeleteMultiple(true);
                  }}
                >
                  <RiDeleteBinLine />
                  Remover
                </TabButtonDelete>
              </span>
            </span>
          </Tooltip>
        </TabButtonArea>

        <TabTitulo>
          <span>{titulo}</span>
        </TabTitulo>
      </Tab>
      <SpanFiltro>{textFiltro}</SpanFiltro>

      <TabContent id="pesquisar" isActive={!hiddenPesquisar}>
        <div style={{ height: '85vh', width: '100%' }}>
          <ThemeProvider theme={theme}>
            <DataGrid
              rows={listCadPessoas}
              columns={columns}
              rowHeight={gridRowHeight}
              checkboxSelection
              selectionModel={selectedIds}
              disableSelectionOnClick
              getRowId={r => r.access_key}
              onSelectionModelChange={e => setSelectedIds(e.selectionModel)}
            />
          </ThemeProvider>
        </div>
      </TabContent>

      <TabContent id="cadasto" isActive={!hiddenCadastrar}>
        <Form ref={formRef} onSubmit={handleSubmit} initialData={cadPessoas}>
          <FormContainer>
            <FormNavigate>
              <Tooltip title="Novo Registro" placement="top">
                <IconButton color="primary" aria-label="adicionar" onClick={() => onNewRegister()}>
                  <AiOutlinePlus />
                </IconButton>
              </Tooltip>

              <Tooltip title="Duplicar Registro" placement="top">
                <IconButton color="primary" aria-label="Duplicar" onClick={() => OnGridRowDuplicate(cadPessoas)}>
                  <MdContentCopy />
                </IconButton>
              </Tooltip>

              <Tooltip title="Excluir Registro" placement="top">
                <IconButton
                  color="primary"
                  aria-label="Excluir"
                  disabled={!cadPessoas?.id}
                  onClick={() => OnConfirmationDeleteSingle(cadPessoas ? cadPessoas.access_key : '')}
                >
                  <RiDeleteBinLine />
                </IconButton>
              </Tooltip>

              <Tooltip title="Cancelar" placement="top">
                <IconButton type="reset" color="primary" aria-label="Cancelar" onClick={() => onCancelRegister()}>
                  <MdClear />
                </IconButton>
              </Tooltip>

              <Tooltip title="Salvar" placement="top">
                <IconButton type="submit" color="primary" aria-label="Confirmar">
                  <AiOutlineSave />
                </IconButton>
              </Tooltip>

              <Tooltip title="Primeiro Registro" placement="top">
                <IconButton color="primary" aria-label="Primeiro" onClick={() => onFirstRegister()}>
                  <AiFillFastBackward />
                </IconButton>
              </Tooltip>

              <Tooltip title="Registro Anterior" placement="top">
                <IconButton color="primary" aria-label="Anterior" onClick={() => onPriorRegister()}>
                  <MdSkipPrevious />
                </IconButton>
              </Tooltip>

              <Tooltip title="Próximo Registro" placement="top">
                <IconButton color="primary" aria-label="Próximo" onClick={() => onNextRegister()}>
                  <MdSkipNext />
                </IconButton>
              </Tooltip>

              <Tooltip title="Último Registro" placement="top">
                <IconButton color="primary" aria-label="Último registro" onClick={() => onLastRegister()}>
                  <AiFillFastForward />
                </IconButton>
              </Tooltip>
            </FormNavigate>

            <FormFields>
              <ContainerFlexRow>
                <ContainerFields field="T200px" className="fieldmr">
                  <span>Código pessoa:</span>
                  <div>
                    {cadPessoas?.codigo ? (
                      <span>{cadPessoas.codigo}</span>
                    ) : (
                      <span style={{ color: 'gray', fontSize: '10px' }}>Será gerado automaticamente</span>
                    )}
                  </div>
                </ContainerFields>

                <ContainerFieldCheckbox field="T400px">
                  <Checkbox name="ativo" />
                  <span>Ativo</span>
                </ContainerFieldCheckbox>
              </ContainerFlexRow>

              <ContainerFlexRow
                style={{
                  justifyContent: 'space-between',
                }}
              >
                <ContainerFields field="T300px" className="fieldmr">
                  <span>Tipo pessoa:</span>
                  <Select id={idfieldSelectUser} name="tipo_pessoa" defaultValue="1-Jurídica" autoFocus>
                    {optionsTipoPessoa.map(itemList => (
                      <option key={itemList} value={itemList}>
                        {itemList}
                      </option>
                    ))}
                  </Select>
                </ContainerFields>

                <ContainerFields field="T300px">
                  <span>Vínculo pessoa:</span>
                  <Select id={idfieldSelectUser} name="vinculo_pessoa" defaultValue="1-Cliente">
                    {optionsVinculoPessoa.map(itemList => (
                      <option key={itemList} value={itemList}>
                        {itemList}
                      </option>
                    ))}
                  </Select>
                </ContainerFields>
              </ContainerFlexRow>

              <ContainerFields field="T100">
                <span>Nome:</span>
                <InputComum name="nome" />
              </ContainerFields>

              <ContainerFields field="T100">
                <span>Nome fantasia:</span>
                <InputComum name="nome_fantasia" />
              </ContainerFields>

              <ContainerFlexRow
                style={{
                  justifyContent: 'space-between',
                }}
              >
                <ContainerFields field="T300px" className="fieldmr">
                  <span>Inscrição federal:</span>
                  <InputComum name="inscricao_federal" />
                </ContainerFields>

                <ContainerFields field="T300px" className="fieldmr">
                  <span>Inscrição estadual:</span>
                  <InputComum name="inscricao_estatual" />
                </ContainerFields>

                <ContainerFields field="T300px">
                  <span>Inscrição municipal:</span>
                  <InputComum name="inscricao_municipal" />
                </ContainerFields>
              </ContainerFlexRow>

              <ContainerFlexRow
                style={{
                  justifyContent: 'space-between',
                }}
              >
                <ContainerFields field="T400px" className="fieldmr">
                  <span>Telefone:</span>
                  <InputComum name="telefone" />
                </ContainerFields>

                <ContainerFields field="T400px">
                  <span>Contato:</span>
                  <InputComum name="contato" />
                </ContainerFields>
              </ContainerFlexRow>

              <ContainerFields field="T100">
                <span>E-mail:</span>
                <InputComum name="email" />
              </ContainerFields>

              <ContainerFields field="T100">
                <span>Endereço:</span>
                <InputComum name="endereco" />
              </ContainerFields>

              <ContainerFields field="T100">
                <span>Observação:</span>
                <InputComum name="obs" />
              </ContainerFields>

              <ContainerFields field="T100">
                <span>Informação 1:</span>
                <InputComum name="inf1" />
              </ContainerFields>

              <ContainerFields field="T100">
                <span>Informação 2:</span>
                <InputComum name="inf2" />
              </ContainerFields>

              <ContainerFields field="T100">
                <span>Informação 3:</span>
                <InputComum name="inf3" />
              </ContainerFields>

              <ContainerFields field="T100">
                <span>Informação 4:</span>
                <InputComum name="inf4" />
              </ContainerFields>

              <ContainerFields field="T100">
                <span>Informação 5:</span>
                <InputComum name="inf5" />
              </ContainerFields>

              <ContainerFieldsHidden>
                <InputComum name="id" hidden />
                <InputComum name="access_key" hidden />
                <InputComum name="id_license" hidden />
                <InputComum name="codigo" hidden />
                <InputComum name="acao" hidden />
              </ContainerFieldsHidden>
            </FormFields>
          </FormContainer>
        </Form>
      </TabContent>

      <FormModalDialogConfirm
        open={openDeleteSingle}
        onClose={() => setOpenDeleteSingle(false)}
        onConfirm={() => handleOnRowDeleteSingle()}
        buttonCancelText="Cancelar"
        buttonConfirmText="Sim"
        formTitle="Excluir?"
        messageConfirm="Tem certeza que deseja excluir?"
      />

      <FormModalDialogConfirm
        open={openDeleteMultiple}
        onClose={() => setOpenDeleteMultiple(false)}
        onConfirm={() => handleOnRowDeleteMultiple()}
        buttonCancelText="Cancelar"
        buttonConfirmText="Sim"
        formTitle="Excluir?"
        messageConfirm="Tem certeza que deseja excluir todos os registros selecionados?"
      />

      <Dialog
        open={openFilter}
        onClose={handleCloseFilter}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">Filtro</DialogTitle>
        <DialogContent>
          <ContainerFields field="T100">
            <span>Nome:</span>
            <ContainerFilterInput>
              <input onChange={handleFilterInputNomeChange} />
            </ContainerFilterInput>
          </ContainerFields>

          <ContainerFields field="T100">
            <span>Inscrição federal:</span>
            <ContainerFilterInput>
              <input onChange={handleFilterInputInscricaoFederalChange} />
            </ContainerFilterInput>
          </ContainerFields>

          <ContainerFields field="T100">
            <span>Tipo pessoa:</span>
            <ContainerFilterSelect>
              <select onChange={handleFilterSelectTipoPessoaChange}>
                <option key="Todos" value="Todos">
                  Todos
                </option>
                {optionsTipoPessoa.map(itemList => (
                  <option key={itemList} value={itemList}>
                    {itemList}
                  </option>
                ))}
              </select>
            </ContainerFilterSelect>
          </ContainerFields>

          <ContainerFields field="T100">
            <span>Vínculo pessoa:</span>
            <ContainerFilterSelect>
              <select onChange={handleFilterSelectVinculoPessoaChange}>
                <option key="Todos" value="Todos">
                  Todos
                </option>
                {optionsVinculoPessoa.map(itemList => (
                  <option key={itemList} value={itemList}>
                    {itemList}
                  </option>
                ))}
              </select>
            </ContainerFilterSelect>
          </ContainerFields>
        </DialogContent>
        <DialogActions>
          <ButtonDialog onClick={handleCloseFilter} color="primary" autoFocus>
            Cancelar
          </ButtonDialog>
          <ButtonDialog onClick={handleOnFilter} color="primary">
            Filtrar
          </ButtonDialog>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openCadPessoaVerify}
        onClose={handleCloseCadPessoaVerify}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">Já existe um cadastro com essa inscrição federal</DialogTitle>
        <DialogContent>
          <ContainerFields field="T100">
            <span>Nome:</span>
            <span>{cadPessoaVerify?.nome}</span>
          </ContainerFields>
          <ContainerFields field="T100">
            <span>Tipo pessoa:</span>
            <span>{cadPessoaVerify?.tipo_pessoa}</span>
          </ContainerFields>
          <ContainerFields field="T100">
            <span>Vínculo pessoa:</span>
            <span>{cadPessoaVerify?.vinculo_pessoa}</span>
          </ContainerFields>
        </DialogContent>
        <DialogActions>
          <ButtonDialog onClick={handleCloseCadPessoaVerify} color="primary" autoFocus>
            Cancelar
          </ButtonDialog>
          <ButtonDialog onClick={handleOnConfirmCreate} color="primary">
            Continuar
          </ButtonDialog>
        </DialogActions>
      </Dialog>

      <Backdrop className={cssLoading.backdrop} open={openLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
};

export default CadPessoas;
